import { EXTERNAL_ID_PREFIX, LOAN_STATUS } from "../../../../constants/commonConstants";
import { PUBLIC_ROUTE } from "../../../../route.constants";
import { smoothScroll } from "@utils/helpers/smoothScroll";
import { createIdQueryString } from "../util";
import { setupLoanRoute } from "@utils/helpers/navigators";

const shouldRouteBeActive = (loanFormState) => {
  const { loanFormResponse } = loanFormState || {};
  const { status } = loanFormResponse || {};

  return status === LOAN_STATUS.DECLINED;
};

const navigateTo = (navigate, loanFormState) => {
  navigate(PUBLIC_ROUTE.DECLINE + createIdQueryString(loanFormState, EXTERNAL_ID_PREFIX));
  smoothScroll();
};

export const declineNavigation = setupLoanRoute({shouldRouteBeActive, navigateTo});